export function getHelperStyle() {
	const helper = {
		color: "#d32f2f",
		backgroundColor: "transparent",
		fontSize: "12px",
		fontWeight: 750,
		lineHeight: 1.25,
		borderRadius: 0,
		padding: 0,
		position: "static",
		bottom: "auto",
		left: "auto",
		zIndex: "auto",
		marginTop: 4,
		marginLeft: 10,
		boxShadow: "none",
		transform: "none",
	};

	return {
		helper,
		helperRadio: {
			...helper,
			marginLeft: 0,
		},
		helperDate: {
			...helper,
			display: "block",
		},
	};
}
